import { render, staticRenderFns } from "./UpgradesList.vue?vue&type=template&id=4b225814&scoped=true&"
import script from "./UpgradesList.vue?vue&type=script&lang=ts&"
export * from "./UpgradesList.vue?vue&type=script&lang=ts&"
import style0 from "./UpgradesList.vue?vue&type=style&index=0&id=4b225814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b225814",
  null
  
)

export default component.exports